import React from 'react';
import ruleModel from './model/ruleModel';
import { SelectBasePrototype } from 'clad';

export const SelectRule = React.forwardRef((props, ref) => {
    const { data, value, onChange, mode, placeholder } = props;
    const handleFetch = ({ query, id, pagination }) =>
        ruleModel.list({ query, id, pagination });

    return (
        <SelectBasePrototype
            mode={mode}
            placeholder={placeholder || _('Select a independent rule')}
            schema={{ idOption: 'id', option: 'rule_name' }}
            fetch={handleFetch}
            onChange={onChange}
            value={value}
            data={data}
        />
    );
});
